import React from 'react';
import { Navigate, Route, Routes as RouterRoutes } from 'react-router-dom';
import NotFound from './pages/NotFound';
import {
  Login,
  CreateTeam,
  SetTeamPassword,
  TeamSetup,
  AcceptInvite,
  ClaimTicket,
  InviteAccept,
  NetworkInviteAccept,
  MeetConnect,
  AdminInviteAccept,
  ReferClaim,
  BuySeat,
  ForgotPassword,
  // Register, — self-registration disabled 2026-06-18
  DelawareRegistration,
  DelawareRegistrationThankYou,
  TeamSelect,
  Role,
  EventSelect,
  ResetPassword,
  VerifyAccount,
  ConfirmEmailChange,
  BattleSelect,
  E7SurveyPreview,
  PrivacyPolicy,
  Terms
} from './pages/main';
import {
  LanguageSelector,
  Profile,
  Settings,
  Badges,
  MyPrizes,
  Billing,
  PublicProfile,
  Connections,
  EditProfile,
  ChangeEmail,
  ChangePassword,
  Wallet,
  Badge,
  MetPeople,
} from './pages/user';
import { Feed, Notifications } from './pages/feed';
import WhoIsHerePage from './pages/event/WhoIsHere';
import EngagementBadges from './pages/event/EngagementBadges';
import { FinanceHome, FinanceDocument, FinanceDocuments } from './pages/finance';
import { SalesHome, SalesCompany, SalesTasks } from './pages/sales';
import { SupplierHome, SupplierEvent, SupplierClosed, CrewDetails } from './pages/supplier';
import { Shop, Checkout, ShopConfirmation, ShopTickets } from './pages/shop';
import PayRedirect from './pages/shop/PayRedirect';
import {
  Home,
  MemberHome,
  PastLabs,
  UpcomingLabs,
  BlogList,
  ReferFriend,
  CompanyMembersPage,
  CompanyMemberPage,
  CompanySignal,
  CompanyHeatmap,
  CompanyStructure,
  CompanyHistory,
  CompanyJourney,
  CompanyPulses,
  CompanyAssessments,
  CompanyTicketsPage,
  CompanyProgrammes,
  CompanyThemes,
  CompanyValues,
  CompanySdgs,
  CompanyHouses,
  PurposeDetail,
  CompanyProgramme,
  CompanyEventEdit,
  CompanyEventPeople,
  CompanyEventTournament,
  CompanyEventTeams,
  CompanyEventGames,
  CompanyEventHouses,
  CompanyEventHouseCup,
  CompanyEventAwards,
  WallOfFame,
  CompanyEventBracket,
  CompanyEventScoring,
  CompanyEventRanking,
  CompanyEventRankingScreen,
  CompanyEventStandings,
  CompanyCalendar,
  EventCategories,
  EventLocations,
  HostEvent,
  EventDoor,
  HostEventSettings,
  HostRunSheet,
  HostBreakouts,
  BreakoutBoard,
  CompanySurveys,
  CompanyEngagement,
  EngagementRules,
  CompanyLeagues,
  CompanyLeague,
  CompanyLeagueDay,
  MyCompetition,
  CompanyFeed,
  Clubs,
  ClubPage,
  ClubsManage,
  PhotoWall,
  KnowYourTribe,
  SendCheer,
  CheersForMe,
  CompanyMissions,
  LabInvite,
  CompanyBlogs,
  MyNetwork,
  MyVouchers,
  MemberBadge,
  MyLab,
  Specialists,
  SpecialistProfile,
  HostProfile,
  EditSpecialistProfile,
  MyClaims,
  MyCases,
  MemberCheckout,
  MembershipCheckout,
  BravosSurvey,
  BravosAssess,
  Teams,
  BrainChallenge,
  PictureChallenge,
  Awards,
  Companies,
  Communities,
  FAQ,
  Battles,
  Battle,
  Leaderboard,
  PublicLeaderboard,
  HouseBoardScreen,
  RaffleScreen,
  McScreen,
  House,
  Map,
  PublicEvent,
  Scores,
  Score,
  Participants,
  CheersLeaderboard,
  ScoringRules,
  Album,
  PublicAlbum,
  ClaimATeam,
  FinalInstructions,
  VenueMap
} from './pages/event';
import {
  Cheers,
  AllCheers,
  EditTeam,
  MergeTeams,
  MeetTheLadies,
  Rivals,
  Planning,
  Team,
  Players,
  AddPlayers,
  Missions,
  Mission,
  SocialMission,
  TeamPhotos,
  ExtraPoints,
  TeamReadiness,
  BonusPoints,
  PublicTeam,
  PublicTeamVote,
  PublicTeamCheers,
  TeamRecap,
  ConfirmCheer,
  TeamLocator
} from './pages/team';
import {
  EditCompany,
  ProjectContract,
  EventCommunication,
  ManageEmployees,
  CompanyReadiness,
  CompanyAwardLB,
  PublicCompany
} from './pages/company';
import {
  Survey,
  EventSurveys,
  SurveyResults,
  Questions
} from './pages/surveys';
import { PublicForm } from './pages/forms';
import PublicReadiness from './pages/readiness/PublicReadiness';
import PublicStackScan from './pages/readiness/PublicStackScan';
import PublicPulse from './pages/pulse/PublicPulse';
import PublicCxoPulse from './pages/pulse/PublicCxoPulse';
import PublicCulturePulse from './pages/pulse/PublicCulturePulse';
import { CreateAccount, Activate } from './pages/account';
import { StorefrontCheckout, StorefrontConfirmation,
         StorefrontConfirmOrder, SupporterAccess } from './pages/storefront';
import SlugEntry from './pages/main/SlugEntry';
import {
  CrewBattles,
  CrewScore,
  CrewTeams,
  CrewScoreTeam,
  CrewScan
} from './pages/crew';


const AppRoutes = () => (
  <RouterRoutes>
    <Route path="/login" element={<Login />} />
    <Route path="/" element={<Login />} />
    <Route path="/forgot-password" element={<ForgotPassword />} />
    {/* Self-registration disabled — signup removed 2026-06-18 */}
    {/* <Route path="/register" element={<Register />} /> */}
    <Route path="/delaware-registration" element={<DelawareRegistration />} />
    <Route path="/delaware-registration-thank-you" element={<DelawareRegistrationThankYou />} />
    <Route path="/team-select" element={<TeamSelect />} />
    <Route path="/role" element={<Role />} />
    <Route path="/event-select" element={<EventSelect />} />
    <Route path="/reset-password" element={<ResetPassword />} />
    {/* Email-confirmation revived 2026-07-23 for storefront verification
        (registers Partner.EmailVerifiedAt; gates nothing). */}
    <Route path="/confirm-email" element={<VerifyAccount />} />
    {/* Confirm a NEW email address (link mailed to the new address) */}
    <Route path="/confirm-email-change" element={<ConfirmEmailChange />} />
    <Route path="/battle-select" element={<BattleSelect />} />
    <Route path="/privacy" element={<PrivacyPolicy />} />
    <Route path="/terms" element={<Terms />} />
    {/* Public hosted CRM form (unauthenticated, by slug) */}
    <Route path="/f/:slug" element={<PublicForm />} />
    {/* Public Bravos readiness scan (unauthenticated teaser, by slug) */}
    <Route path="/readiness/:slug" element={<PublicReadiness />} />
    {/* Public Engagement Stack Scan (unauthenticated sales instrument, by slug) */}
    <Route path="/stack-scan/:slug" element={<PublicStackScan />} />
    {/* Public anonymous Bravos employee pulse (unauthenticated, by slug) */}
    <Route path="/pulse/:slug" element={<PublicPulse />} />
    {/* Public anonymous Bravos CxO pulse (unauthenticated, by slug) */}
    <Route path="/cxo-pulse/:slug" element={<PublicCxoPulse />} />
    {/* Public anonymous Bravos culture pulse (unauthenticated, by slug) */}
    <Route path="/culture-pulse/:slug" element={<PublicCulturePulse />} />
    {/* Free Bravos account from the storefront (unauthenticated, by STOREFRONT slug) */}
    <Route path="/create-account/:slug" element={<CreateAccount />} />
    {/* Landing page for the activation link mailed by the step above */}
    <Route path="/activate/:token" element={<Activate />} />
    {/* Public self-serve team creation (unauthenticated, by edition id) */}
    <Route path="/create-team/:editionId" element={<CreateTeam />} />
    {/* Set-password step reached from the create-team email link */}
    <Route path="/set-team-password/:token" element={<SetTeamPassword />} />
    {/* Company + teams setup, right after a team is created */}
    <Route path="/team-setup" element={<TeamSetup />} />
    {/* Public accept-team-invite (unauthenticated, by signed token) */}
    <Route path="/join/:token" element={<AcceptInvite />} />
    {/* Public claim-a-ticket (unauthenticated, by signed token) */}
    <Route path="/claim/:token" element={<ClaimTicket />} />
    {/* Public accept-a-Bravos-Lab-invite (unauthenticated, by signed token) */}
    <Route path="/invite/:token" element={<InviteAccept />} />
    <Route path="/network-invite/:token" element={<NetworkInviteAccept />} />
    {/* Public networking-QR landing (unauthenticated read; the connect POST needs a session) */}
    <Route path="/meet/:token" element={<MeetConnect />} />
    {/* Public accept-a-company-admin-invite (unauthenticated, by signed token) */}
    <Route path="/admin-invite/:token" element={<AdminInviteAccept />} />
    {/* Public refer-a-friend claim (unauthenticated, by signed token) */}
    <Route path="/refer/:token" element={<ReferClaim />} />
    {/* Public claim through a player's personal code (early list for the next edition) */}
    <Route path="/friend/:code" element={<ReferClaim mode="code" />} />
    <Route path="/buy/:token" element={<BuySeat />} />
    {/* Public event photo album (unauthenticated, by event id) */}
    <Route path="/public-album/:eventId" element={<PublicAlbum />} />
    {/* Public host screen (unauthenticated, by partner id) */}
    <Route path="/host/:partnerId" element={<HostProfile />} />
    {/* Public specialist profile (unauthenticated, by partner id) */}
    <Route path="/specialist/:id" element={<SpecialistProfile />} />
    {/* Public event ranking / final results (unauthenticated, by event id) */}
    <Route path="/public-leaderboard/:eventId" element={<PublicLeaderboard />} />
    {/* Public house standing for a lobby display / beamer (unauthenticated, by a revocable
        token minted on /houses) */}
    <Route path="/house-board/:token" element={<HouseBoardScreen />} />
    {/* The live raffle on the big screen (unauthenticated, by a revocable token from Machina) */}
    <Route path="/raffle-screen/:token" element={<RaffleScreen />} />
    {/* The MC on stage: run sheet, jingle timer, The Vibe and the top 5 (unauthenticated, by a
        revocable token from Machina ▸ The Vibe) */}
    <Route path="/mc/:token" element={<McScreen />} />
    <Route path="/public-team/:teamId" element={<PublicTeam />} />
    <Route path="/public-team/:teamId/vote" element={<PublicTeamVote />} />
    <Route path="/public-team/:teamId/cheers" element={<PublicTeamCheers />} />
    <Route path="/public-team/:teamId/recap" element={<TeamRecap />} />
    <Route path="/confirm-cheer" element={<ConfirmCheer />} />
    <Route path="/e7-preview" element={<E7SurveyPreview />} />
    <Route path="/e7-preview/login" element={<E7SurveyPreview variant="login" />} />
    <Route path="/e7-preview/start" element={<E7SurveyPreview variant="start" />} />
    <Route path="/e7-preview/scale-10" element={<E7SurveyPreview variant="scale-10" />} />
    <Route path="/e7-preview/sliders" element={<E7SurveyPreview variant="sliders" />} />
    <Route path="/e7-preview/pulse-hi" element={<E7SurveyPreview variant="pulse-hi" />} />
    <Route path="/e7-preview/qr" element={<E7SurveyPreview variant="qr" />} />
    <Route path="/e7-preview/dashboard-ar" element={<E7SurveyPreview variant="dashboard-ar" />} />

    {/* SALES — our own reps working the CRM on the road. GET /api/home redirects
        role 'sales' to /sales-home, which is how the NavBar's hard-coded /home
        lands here. Every screen is gated server-side on a per-BU 'sales' grant. */}
    <Route path="/sales-home" element={<SalesHome />} />
    <Route path="/sales/company/:companyId" element={<SalesCompany />} />
    <Route path="/sales-tasks" element={<SalesTasks />} />

    {/* SUPPLIER PORTAL — a company working for an event (supplier, goodiebag / raffle /
        marketplace) confirms what the venue needs and ticks who is coming. Reached through the
        magic link /api/ops/<token>; GET /api/home sends role 'supplier' here. CrewDetails is a
        crew member's own details for the venue, same engine. */}
    <Route path="/supplier" element={<SupplierHome />} />
    <Route path="/supplier/event/:eventId" element={<SupplierEvent />} />
    <Route path="/supplier/preview/:token" element={<SupplierEvent />} />
    <Route path="/supplier/closed" element={<SupplierClosed />} />
    <Route path="/crew-details" element={<CrewDetails />} />

    {/* FINANCE — photographing the invoices we receive. A page of its own, one
        discreet button down from the road home: two jobs competing for the top
        of one screen means the frequent one loses, and looking a company up
        before walking in is the frequent one. Somebody granted ONLY the capture
        still gets it inline on the internal home — for them it is not a detour.
        Every screen is gated server-side on a per-BU 'finance' grant.
        /finance/new is the confirm form for a photo nothing has stored yet, so
        it comes BEFORE /finance/:documentId or 'new' would be read as a
        document id. */}
    <Route path="/finance-home" element={<FinanceHome />} />
    <Route path="/finance/list" element={<FinanceDocuments />} />
    <Route path="/finance/new" element={<FinanceDocument />} />
    <Route path="/finance/:documentId" element={<FinanceDocument />} />

    {/* EVENT */}
    <Route path="/home" element={<Home />} />
    {/* The game Home on one event, opened from the company admin home ("Manage current event").
        GET /api/home?manage=1 keeps a company admin here instead of sending them back. */}
    <Route path="/event-home" element={<Home />} />
    {/* Refer a friend (authed compose page, shared by HT/PLG + Bravos homes) */}
    <Route path="/refer" element={<ReferFriend />} />
    {/* Bravos member landing (GET /api/home redirects active members here) */}
    <Route path="/member-home" element={<MemberHome />} />
    <Route path="/member-home/past" element={<PastLabs />} />
    <Route path="/member-home/upcoming" element={<UpcomingLabs />} />
    <Route path="/blogs" element={<BlogList />} />
    {/* Bravos contact-person "manage our company's Bravos Members" (its own screen) */}
    <Route path="/company-members" element={<CompanyMembersPage />} />
    {/* One colleague, where the admin actions on that person live (the list stays a list) */}
    <Route path="/company-members/:memberId" element={<CompanyMemberPage />} />
    {/* Bravos contact-person Company Signal Record (firmographic signals for the methodology) */}
    <Route path="/company-signal" element={<CompanySignal />} />
    {/* The history behind those tiles — every KPI the nightly snapshot has written down */}
    <Route path="/company-heatmap" element={<CompanyHeatmap />} />
    <Route path="/company-structure" element={<CompanyStructure />} />
    <Route path="/company-structure/:unitId" element={<CompanyStructure />} />
    <Route path="/company-history" element={<CompanyHistory />} />
    {/* The screens behind the company-admin home tiles: one job each, one number on the home. */}
    <Route path="/journey" element={<CompanyJourney />} />
    <Route path="/pulses" element={<CompanyPulses />} />
    <Route path="/assessments" element={<CompanyAssessments />} />
    <Route path="/company-tickets" element={<CompanyTicketsPage />} />
    {/* A customer running its own events. The first four are the admin's (behind the
        engagement-product gate); /company-events is every employee's. */}
    {/* ★ These five were ONE screen with a tab strip until they each grew their own stats.
        /programmes still answers the old ?tab= links by redirecting to whichever of the other
        four the tab became. /themes, /programmes and /houses are the engagement product's;
        /values and /sdgs belong to every Bravos company, so the home draws those two tiles
        whether the product was bought or not.
        ⚠️ /houses took over a route that used to point at a dead Hercules stub — nothing linked
        to it. All four are in RESERVED_SLUGS, so no BU can claim one as its storefront. */}
    <Route path="/programmes" element={<CompanyProgrammes />} />
    <Route path="/themes" element={<CompanyThemes />} />
    <Route path="/values" element={<CompanyValues />} />
    <Route path="/sdgs" element={<CompanySdgs />} />
    <Route path="/houses" element={<CompanyHouses />} />
    {/* One declared value, or one of the 17 goals — the screen behind a chip on the home
        badge. Open to an employee too, read-only. */}
    <Route path="/purpose/:kind/:itemId" element={<PurposeDetail />} />
    {/* No id = the programme the company is in right now; the screen picks up the rest. */}
    <Route path="/programme" element={<CompanyProgramme />} />
    <Route path="/programme/:programmeId" element={<CompanyProgramme />} />
    {/* Editing the event is the WIDER of the two owner doors: the admin, an employee attached
        as host, and the external facilitator we sent in. Running it is the narrower one below.
        Both gates are on the server. */}
    <Route path="/company-event/:eventId/edit" element={<CompanyEventEdit />} />
    <Route path="/company-event/:eventId/people" element={<CompanyEventPeople />} />
    {/* What kind of competition this event is — what competes, and how it is played. An event
        with no stage row is an ordinary event, which is every event that exists today. Same
        server gate as the run screen: a host reads it, the admin decides it. */}
    <Route path="/company-event/:eventId/tournament" element={<CompanyEventTournament />} />
    {/* The field that competes. A break-out of the competition screen rather than a section of
        it: making twelve teams and filling them five ways is a screenful on its own, and the
        cockpit's job is to say whether it has been done. */}
    <Route path="/company-event/:eventId/teams" element={<CompanyEventTeams />} />
    <Route path="/company-event/:eventId/games" element={<CompanyEventGames />} />
    {/* The houses the day is played by: who competes for which, and the points. A break-out
        and not a block on the cockpit because it answers a different question — the cockpit
        says whether the competition is ready, this says who is winning and why. The houses
        themselves are invented on /programmes, where the values are. */}
    <Route path="/company-event/:eventId/houses" element={<CompanyEventHouses />} />
    {/* ★ The day's RANKING as house points, on PLACE — a second, deliberate standing beside the
        houses screen's raw team-score sum. Its own screen because it is the only one that reads
        an outcome and writes a result. */}
    <Route path="/company-event/:eventId/house-cup" element={<CompanyEventHouseCup />} />
    {/* The prizes at the end of the night: what is handed out, and to whom. Its own screen and
        not a block on the host screen because it is a RUNNING ORDER — a person with a microphone
        going down a list, revealing one row at a time — and because it is the only screen here
        whose rows are invented rather than computed. Host-gated like the run screen: handing out a
        prize IS running the event. */}
    <Route path="/company-event/:eventId/awards" element={<CompanyEventAwards />} />
    {/* The knockout being PLAYED: the draw, then a result per match. A break-out and not another
        block on the cockpit because it answers a different question — the cockpit says whether
        the competition is ready, this says who is winning. Host-readable and host-scorable; only
        the company admin may draw or redraw, which the payload gates on its own. */}
    <Route path="/company-event/:eventId/bracket" element={<CompanyEventBracket />} />
    {/* Running the day: what happened in each heat, and the standing that comes out of it. Both
        host-gated — entering a result is running the day, not deciding what the day is. */}
    <Route path="/company-event/:eventId/scoring" element={<CompanyEventScoring />} />
    <Route path="/company-event/:eventId/ranking" element={<CompanyEventRanking />} />
    {/* The same standing, on a wall. Its own screen and not a mode of the one above, because a
        board for a beamer is a different object: no nav, no card, rows sized off the screen, it
        pages itself, it refreshes itself, and it shows the CAPPED board — what the players can
        see — so the projector cannot give the ceremony away. */}
    <Route path="/company-event/:eventId/ranking/screen" element={<CompanyEventRankingScreen />} />
    {/* And the SAME standing again, for a colleague who runs none of it. Its own screen and not a
        looser gate on /ranking above, because the employee read is a different payload — the
        board, the day's houses and their own points, with nothing to post back. It keeps the
        ceremony cap, so the phone in the room never runs ahead of the board on the wall. */}
    <Route path="/company-event/:eventId/standings" element={<CompanyEventStandings />} />
    <Route path="/company-events" element={<CompanyCalendar />} />
    {/* Every prize this company ever won, and every prize ever handed out at one of its
        evenings — grouped by evening, newest first. Reached from the trophy tile on the admin
        home; open to any colleague of the company, because everything on it was announced out
        loud and is already on the winners' own profiles. */}
    <Route path="/wall-of-fame" element={<WallOfFame />} />
    {/* The BU-wide category catalogue, reached from the "+" on the calendar's
        filter row. Admin-gated by its own fetch. */}
    <Route path="/event-categories" element={<EventCategories />} />
    {/* Where the company holds its events — the address book behind the picker in the event
        editor, reached from under the map field. Admin-gated by its own fetch. */}
    <Route path="/our-locations" element={<EventLocations />} />
    {/* Running the event on the day. Open to the engagement admin AND to an employee attached
        as its host — the gate is on the server, and it is the only screen with both. */}
    <Route path="/host-event/:eventId" element={<HostEvent />} />
    {/* The door: the attendance list by name, marked by hand, plus whoever turns up unannounced.
        Behind the counts on the host screen and under the SAME gate — a public Lab has no
        organising company, so the admin's /company-event/:id/people cannot open on one and the
        person running the evening would have a number and no names. */}
    <Route path="/host-event/:eventId/door" element={<EventDoor />} />
    {/* What the COMPANY decides about the event — categories, who may register, published,
        cancelled, deleted. Behind the cog on the host screen and NOT on the editor: the
        external facilitator we send in edits the event and does not own it. */}
    <Route path="/host-event/:eventId/settings" element={<HostEventSettings />} />
    {/* The same run sheet, every day of it at once — writing a multi-day programme rather
        than changing one during the event. Same gate, on the server. */}
    <Route path="/host-event/:eventId/run-sheet" element={<HostRunSheet />} />
    {/* Splitting the room while it happens: draw the groups, upload them, move somebody,
        and the wall the room reads. Same gate as the host screen, on the server. */}
    <Route path="/host-event/:eventId/breakouts" element={<HostBreakouts />} />
    <Route path="/host-event/:eventId/breakout-board" element={<BreakoutBoard />} />
    {/* The survey library: write one, run it on every event, read it rolled up. */}
    <Route path="/company-surveys" element={<CompanySurveys />} />
    {/* Who is actually taking part: the roster with a number beside every name, and the weights
        behind it. Admin-gated by its own fetch — an employee never sees anybody's score. */}
    <Route path="/engagement" element={<CompanyEngagement />} />
    {/* What counts, and how much. Its own screen rather than a card under the roster:
        settings that rescore a company on save are not something to scroll past. */}
    <Route path="/engagement/rules" element={<EngagementRules />} />
    <Route path="/engagement/badges" element={<EngagementBadges />} />
    <Route path="/company-feed" element={<CompanyFeed />} />
    {/* Clubs inside an engagement customer: the directory, the company admin's overview, and
        one club's page (calendar, feed, photos, members). /clubs/manage before :clubId. */}
    <Route path="/clubs" element={<Clubs />} />
    <Route path="/clubs/manage" element={<ClubsManage />} />
    <Route path="/clubs/:clubId" element={<ClubPage />} />
    {/* The photo wall — the same pictures the stream carries, ordered three ways (F8). */}
    <Route path="/photo-wall" element={<PhotoWall />} />
    {/* Do you know your tribe? — the guess-who. Its own screen rather than a widget on the wall:
        finding a colleague and playing a game about them are two different errands. The path
        carries no id on purpose — the round's roster is read off the token, and a query param
        would be stripped by usePersistUrlParams on arrival. */}
    <Route path="/know-your-tribe" element={<KnowYourTribe />} />
    {/* Recognition (F7): cheering a colleague for something the company stands for. The composer
        takes the person in the PATH so the wall and a profile can send you straight into it with
        the "who" already answered — a query param would be stripped by usePersistUrlParams. */}
    <Route path="/cheer" element={<SendCheer />} />
    <Route path="/cheer/:partnerId" element={<SendCheer />} />
    {/* Where a cheer is answered. Its own screen, not a modal on the home: the choice it asks for
        is the only reason a pending cheer exists, and the bell and the mail both land here. */}
    <Route path="/cheers-for-me" element={<CheersForMe />} />
    {/* Missions (F3): what is open, what I handed in, and — for the admin — the catalogue and
        the approval queue. One screen for both roles; the server decides which half is drawn. */}
    <Route path="/company-missions" element={<CompanyMissions />} />
    {/* Leagues (F6): one competition over days that are not next to each other. The days are
        ordinary events under a master, so they are created, published and hosted through the
        screens that already exist; these three only add the standing and how it is filled. */}
    <Route path="/leagues" element={<CompanyLeagues />} />
    <Route path="/league/:leagueId" element={<CompanyLeague />} />
    {/* Closing one day into the standing — its own screen because it is the one action here
        that is hard to undo casually. */}
    <Route path="/league/:leagueId/day/:eventId" element={<CompanyLeagueDay />} />
    {/* The competition as an EMPLOYEE has it: their house, the standing, their teams and every
        day the company plays. Beside the leagues because it is the same subject read from the
        other end — those three screens are for whoever runs the competition, this one is for
        whoever is in it. Nothing to post back; the server's gate is the employee one. */}
    <Route path="/my-competition" element={<MyCompetition />} />
    {/* Pick a Lab, tick the colleagues, send — replaces the per-row copy-link buttons.
        The Lab rides in the PATH, not a query param: the weekly digest links straight to
        one, and usePersistUrlParams strips query params on arrival. */}
    <Route path="/invite-to-lab" element={<LabInvite />} />
    <Route path="/invite-to-lab/:eventId" element={<LabInvite />} />
    {/* The company's own blogs: the articles it writes and the RSS feeds it mixes into what
        its people read. The path still says "feeds" because that is what live links point at. */}
    <Route path="/company-feeds" element={<CompanyBlogs />} />
    <Route path="/my-network" element={<MyNetwork />} />
    <Route path="/my-vouchers" element={<MyVouchers />} />
    <Route path="/member-badge" element={<MemberBadge />} />
    <Route path="/my-lab" element={<MyLab />} />
    <Route path="/specialists" element={<Specialists />} />
    <Route path="/edit-specialist-profile" element={<EditSpecialistProfile />} />
    <Route path="/my-claims" element={<MyClaims />} />
    <Route path="/my-cases" element={<MyCases />} />
    {/* Bravos member in-app Lab checkout (pre-filled + voucher + payment) */}
    <Route path="/book/:eventId" element={<MemberCheckout />} />
    {/* Bravos individual/company membership checkout, sold on the Season */}
    <Route path="/join" element={<MembershipCheckout />} />
    {/* Bravos member assessment (authenticated) */}
    <Route path="/bravos/survey/:key" element={<BravosSurvey />} />
    {/* Public distributed assessment via a share link (no account) */}
    <Route path="/bravos/assess/:token" element={<BravosAssess />} />
    <Route path="/teams" element={<Teams />} />
    {/* <Route path="/brain-challenge" element={<BrainChallenge />} />
    <Route path="/picture-challenge" element={<PictureChallenge />} /> */}
    <Route path="/awards" element={<Awards />} />
    <Route path="/companies" element={<Companies />} />
    <Route path="/communities" element={<Communities />} />
    <Route path="/faq" element={<FAQ />} />
    <Route path="/battles" element={<Battles />} />
    <Route path="/battle" element={<Battle />} />
    <Route path="/leaderboard" element={<Leaderboard />} />
    <Route path="/who-is-here" element={<WhoIsHerePage />} />
    <Route path="/house" element={<House />} />
    {/* <Route path="/map" element={<Map />} /> */}
    <Route path="/public-event/:eventId" element={<PublicEvent />} />
    <Route path="/scores" element={<Scores />} />
    <Route path="/score" element={<Score />} />
    <Route path="/participants" element={<Participants />} />
    <Route path="/cheers-leaderboard" element={<CheersLeaderboard />} />
    <Route path="/scoring-rules" element={<ScoringRules />} />
    <Route path="/album" element={<Album />} />
    <Route path="/claim-a-team" element={<ClaimATeam />} />
    <Route path="/final-instructions" element={<FinalInstructions />} />
    <Route path="/venue-map" element={<VenueMap />} />

    {/* USER */}
    <Route path="/language" element={<LanguageSelector />} />
    <Route path="/profile" element={<Profile />} />
    {/* <Route path='/settings' element={<Settings />} /> */}
    <Route path='/badges' element={<Badges />} />
    <Route path='/my-prizes' element={<MyPrizes />} />
    <Route path='/billing' element={<Billing />} />
    <Route path='/public-profile' element={<PublicProfile />} />
    <Route path='/u/:userId' element={<PublicProfile />} />
    <Route path='/connections' element={<Connections />} />
    <Route path='/edit-profile' element={<EditProfile />} />
    <Route path='/change-email' element={<ChangeEmail />} />
    <Route path='/change-password' element={<ChangePassword />} />
    <Route path='/wallet' element={<Wallet />} />
    <Route path='/badge' element={<Badge />} />
    <Route path='/my-connections' element={<MetPeople />} />

    {/* TEAM */}
    <Route path="/cheers" element={<Cheers />} />
    <Route path="/all-cheers" element={<AllCheers />} />
    <Route path="/edit-team" element={<EditTeam />} />
    <Route path="/merge-teams" element={<MergeTeams />} />
    <Route path="/meet-the-ladies" element={<MeetTheLadies />} />
    <Route path="/rivals" element={<Rivals />} />
    <Route path="/team" element={<Team />} />
    <Route path="/planning" element={<Planning />} />
    <Route path="/players" element={<Players />} />
    <Route path="/add-players" element={<AddPlayers />} />
    <Route path="/missions" element={<Missions />} />
    <Route path="/mission" element={<Mission />} />
    {/* Video submissions were merged into /missions; keep old links working */}
    <Route path="/social-missions" element={<Navigate to="/missions" replace />} />
    <Route path="/social-mission" element={<SocialMission />} />
    <Route path="/team-photos" element={<TeamPhotos />} />
    <Route path="/extra-points" element={<ExtraPoints />} />
    <Route path="/team-readiness" element={<TeamReadiness />} />
    <Route path="/bonus-points" element={<BonusPoints />} />
    <Route path="/find-team" element={<TeamLocator />} />
    <Route path="/find-team/:teamId" element={<TeamLocator />} />

    {/* A failed online payment: the bell lands here and hands over to /api/pay/<order> */}
    <Route path="/pay/:orderId" element={<PayRedirect />} />

    {/* SHOP (contact persons) */}
    <Route path="/shop" element={<Shop />} />
    <Route path="/shop/checkout" element={<Checkout />} />
    <Route path="/shop/confirmation" element={<ShopConfirmation />} />
    <Route path="/shop/tickets" element={<ShopTickets />} />

    {/* FEED */}
    <Route path="/feed" element={<Feed />} />
    <Route path="/notifications" element={<Notifications />} />

    {/* COMPANY */}
    <Route path="/edit-company" element={<EditCompany />} />
    {/* A Fabrica project's contract: the "Read and sign the agreement" mail lands here */}
    <Route path="/contract/:eventId" element={<ProjectContract />} />
    <Route path="/event-communication/:eventId" element={<EventCommunication />} />
    <Route path="/manage-employees" element={<ManageEmployees />} />
    <Route path="/company-readiness" element={<CompanyReadiness />} />
    <Route path="/company-award-lb" element={<CompanyAwardLB />} />
    <Route path="/public-company/:companyId" element={<PublicCompany />} />

    {/* SURVEYS */}
    <Route path="/survey" element={<Survey />} />
    <Route path="/event-surveys" element={<EventSurveys />} />
    <Route path="/survey-results" element={<SurveyResults />} />
    <Route path="/questions" element={<Questions />} />

    {/* CREW */}
    <Route path="/crew-battles" element={<CrewBattles />} />
    <Route path="/crew-score" element={<CrewScore />} />
    <Route path="/crew-teams" element={<CrewTeams />} />
    <Route path="/crew-score-team" element={<CrewScoreTeam />} />
    <Route path="/crew-scan" element={<CrewScan />} />


    {/* Public brand storefront (unauthenticated, by slug) — React Router ranks
        static segments above this dynamic one, so every page above always wins;
        an unknown slug renders the storefront's own not-found state. */}
    <Route path="/:slug" element={<SlugEntry />} />
    <Route path="/:slug/checkout/:eventId" element={<StorefrontCheckout />} />
    <Route path="/:slug/confirmation" element={<StorefrontConfirmation />} />
    {/* The QR code at the venue: become a supporter of the brand's event of the day. */}
    <Route path="/:slug/support" element={<SupporterAccess />} />
    <Route path="/:slug/support/:eventId" element={<SupporterAccess />} />
    {/* The link in the "confirm your order" mail — this is where an invoice order
        is actually placed, a week after the buyer pressed the button. */}
    <Route path="/:slug/confirm-order" element={<StorefrontConfirmOrder />} />

    {/* 404 - Catch-All Route */}
    <Route path="*" element={<NotFound />} />  {/* Catch-all route for 404 */}

  </RouterRoutes>
);

export default AppRoutes;
